import type { TicketStatus, Prioritet } from './types';

export const STATUS_LABELS: Record<TicketStatus, string> = {
  NY: 'Ny',
  UNDER_ARBEID: 'Under arbeid',
  VENTER_KUNDE: 'Venter på kunde',
  VENTER_INTERNT: 'Venter internt',
  LOST: 'Løst',
  LUKKET: 'Lukket',
};

export const STATUS_COLORS: Record<TicketStatus, string> = {
  NY: 'bg-blue-100 text-blue-700',
  UNDER_ARBEID: 'bg-amber-100 text-amber-700',
  VENTER_KUNDE: 'bg-purple-100 text-purple-700',
  VENTER_INTERNT: 'bg-orange-100 text-orange-700',
  LOST: 'bg-green-100 text-green-700',
  LUKKET: 'bg-slate-200 text-slate-600',
};

export const PRIORITET_LABELS: Record<Prioritet, string> = {
  LAV: 'Lav',
  NORMAL: 'Normal',
  HOY: 'Høy',
  KRITISK: 'Kritisk',
};

export const PRIORITET_COLORS: Record<Prioritet, string> = {
  LAV: 'bg-slate-100 text-slate-600',
  NORMAL: 'bg-blue-100 text-blue-700',
  HOY: 'bg-orange-100 text-orange-700',
  KRITISK: 'bg-red-100 text-red-700',
};

export const STATUS_ORDER: TicketStatus[] = [
  'NY',
  'UNDER_ARBEID',
  'VENTER_KUNDE',
  'VENTER_INTERNT',
  'LOST',
  'LUKKET',
];

export function formatSakNr(sakNr: number): string {
  return `SAK-${sakNr}`;
}

export function formatDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString('nb-NO', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function formatDateTime(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleString('nb-NO', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatRelative(iso: string): string {
  const d = new Date(iso);
  const now = new Date();
  const diffMs = now.getTime() - d.getTime();
  const diffMin = Math.floor(diffMs / 60000);
  const diffHr = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHr / 24);

  if (diffMin < 1) return 'nå nettopp';
  if (diffMin < 60) return `${diffMin} min siden`;
  if (diffHr < 24) return `${diffHr} t siden`;
  if (diffDay < 7) return `${diffDay} dager siden`;
  return formatDate(iso);
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${Math.round(bytes / (1024 * 1024))} MB`;
}

export function getInitials(navn: string): string {
  return navn
    .split(' ')
    .map((n) => n[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
}
